module.exports = __webpack_public_path__ + "img/groupicon.7bcb0b4e.svg";